<div fxLayout="column">
    <form [formGroup]="firstFormGroup">

        
        <!-- Subscription Type -->

        <div *ngIf="firstFormGroup.get('subscriptionType').value != 'Weekly'"  class="topspace" style="margin: 0.25em 0;" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
            <span  fxFlex="50" fxFlex.xs="100">
                <button class="cart-button lt" color="primary" fxFlex="35" (click)="decreaseQtyNormal()">
                    <span class="material-icons">remove</span>
                </button>
                <button class="cart-button center" fxFlex="30" color="primary" matTooltip="Add to cart">
                    {{ firstFormGroup.get('qty').value }}
                </button>
                <button  fxFlex="35" class="cart-button rt" color="primary" (click)="increaseQtyNormal() 
                    ">
                    <span class="material-icons">add</span>
                </button>
            </span>

        </div>

        <div  class="topspace" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">

            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Select Date Range</mat-label>
                <mat-date-range-input [min]="todayDate" [max]="maxDate" [rangePicker]="picker">
                  <input formControlName="startDate" matStartDate placeholder="Start date">
                  <input  (ngModelChange)="onDateRangeChange()" formControlName="endDate" matEndDate placeholder="End date">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>

              <mat-form-field fxFlex="50" appearance="outline" fxFlex>
                <mat-label>Subscription Type</mat-label>
                <mat-select  formControlName="subscriptionType">
                    <mat-option   (onSelectionChange)="selectType($event,status.viewValue)" *ngFor="let status of subscriptionType" [value]="status.viewValue">
                        {{status.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
      
            
        </div>

        <button   *ngIf="!showType" fxLayoutGap="20px" (click)="confirm()" style="color:#ffffff" class="primary" mat-flat-button>
            <span>
                Confirm Date
            </span>
        </button>

        <div *ngIf="showType"  fxLayoutGap="20px">
     
           

    
<div *ngIf="showType">
        <div *ngIf="init" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
            <span *ngIf="firstFormGroup.get('subscriptionType').value === 'Weekly'">
                <b>Select Weeks</b>
                <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center">
            
                    <ng-container class="padding-10" *ngFor="let day  of weekDays;let i=index">
                      
                        <div fxFlex.xs="50" class="padding-10" fxLayout="column">
                        
                            <button fxFlex.xs="50"  [disabled]=" dayMap[ weekDays[i]]  === 0" (click)="pushObjectToDayActivity( weekDays[i])"
                             style="color:#ffffff" class="primary" mat-flat-button>
                                <span>{{  weekDays[i] }}</span>
                            </button>
                        </div>
                    </ng-container>
                </div>
            </span>
        </div>


        <div *ngIf="selectedDay" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
            <b>Select Quantity per day</b>
        </div>

        <div fxLayout="row wrap"  *ngIf="firstFormGroup.get('subscriptionType').value === 'Weekly'">

     
        <div *ngFor="let dayFormGroup of daysFormArray.controls; let i = index" fxFlex="100"  fxLayout="row" fxLayout.lt-md="column"
            fxLayoutGap="20px">
            <div fxFlex="100" fxLayoutAlign="center center" class="topspace">
                <div fxLayoutAlign="start center" fxFlex="50"  fxLayout="column">
                    <span>{{ dayFormGroup.value.day }}</span>
                </div>
                <div fxLayoutAlign="end center" fxLayout="row" fxFlex="50">
                    <span fxFlex="100" fxFlex.xs="100">
                        <button class="cart-button lt" color="primary" fxFlex="35" (click)="decreaseQty(i)">
                            <span class="material-icons">remove</span>
                        </button>
                        <button class="cart-button center" fxFlex="30" color="primary" matTooltip="Add to cart">
                            {{ dayFormGroup.get('qty').value }}
                        </button>
                        <button fxFlex="35" class="cart-button rt" color="primary" (click)="increaseQty(i) 
                            ">
                            <span class="material-icons">add</span>
                        </button>
                    </span>
                </div>
            </div>
        </div>
    

  
        <div *ngIf="initCartButton" fxFlex="100">
            <calsoft-controls  (emitQtySubscription)="getSub($event)"  [data]="data" [product]="configproduct"
            [subscription]="subscription"
            [configproduct]="product" [type]="'subscription'" [buttonArray]="buttonArray">
        </calsoft-controls>
        </div>
      

        </div>

        

</div>


<div  *ngIf="firstFormGroup.get('subscriptionType').value === 'Daily' " fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">

    <div *ngIf="initCartButton" fxFlex="100">
        <calsoft-controls   (emitQtySubscription)="getSub($event)"   [data]="data" [product]="configproduct"
        [subscription]="subscription"
        [configproduct]="product" [type]="'subscription'" [buttonArray]="buttonArray">
    </calsoft-controls>
    </div>

    
</div>

        </div>
    </form>
</div>